// Shared master lists for BusinessSignupForm & AgencySignupForm

// Connecticut Counties
export const counties = [
  "Fairfield",
  "Hartford",
  "Litchfield",
  "Middlesex",
  "New Haven",
  "New London",
  "Tolland",
  "Windham"
];

// Industries
export const industries = [
  "Healthcare",
  "Finance",
  "Retail",
  "Education",
  "Hospitality",
  "Construction",
  "Manufacturing",
  "Technology",
  "Transportation",
  "Food & Beverage",
  "Media & Entertainment",
  "Real Estate & Housing",
  "Nonprofit",
  "Government/Public Sector",
  "Other"
];

// Marketing Channels
export const channels = [
  "TV",
  "Radio",
  "Social Media (Facebook, Instagram)",
  "YouTube",
  "Google Search Ads",
  "Print Ads (Newspapers/Magazines)",
  "Billboards/Outdoor Ads",
  "Email Marketing",
  "Events & Sponsorships",
  "Other"
];

// KPIs (Key Performance Indicators)
export const kpis = [
  "Leads",
  "Website Traffic",
  "Conversions",
  "Brand Awareness",
  "Engagement",
  "Sales",
  "ROI"
];

//  Campaign Objectives
export const campaignObjectives = [
  "Increase brand awareness",
  "Build or strengthen brand identity",
  "Introduce a new product or service",
  "Differentiate from competitors",
  "Improve market positioning",
  "Create desire for your offering",
  "Support community engagement",
  "Grow your social media following",
  "Educate your audience",
  "Drive traffic",
  "Generate leads",
  "Encourage call to action",
  "Increase sales",
  "Promote a time-sensitive offer"
];

// Household Types
export const householdTypes = [
  "Single individuals",
  "Married couples",
  "Families with children",
  "Families without children"
];

//  Life Stages
export const lifeStages = [
  "Young professionals",
  "College students",
  "Parents with young children",
  "Seniors (55+)",
  "Remote workers"
];

// Age Groups (used conditionally)
export const ageGroups = [
  "11 and under",
  "12-18",
  "19-24",
  "25-34",
  "35-44",
  "45-54",
  "55-64",
  "65-74",
  "75+",
  "All ages"
];

//  Marketing Assets
export const marketingAssets = [
  "Business cards",
  "Brochures",
  "Website",
  "Facebook",
  "Instagram",
  "YouTube",
  "Other",
  "None"
];
